import { z } from "zod";
import {
	optionalFilterString,
	optionalFilterStringArray,
} from "@/schemas/filter.schema";
import {
	SchedulerContentView,
	SchedulerViewMode,
} from "@/features/scheduler/types/scheduler.types";

export const schedulerFilterSchema = z.object({
	search: optionalFilterString,
	viewMode: z
		.nativeEnum(SchedulerViewMode)
		.optional()
		.default(SchedulerViewMode.WEEK),
	serviceUnavailability: z.boolean().optional(),
	overdue: z.boolean().optional(),
	availableOnly: z.boolean().optional(),
	availableOnlyStart: optionalFilterString,
	availableOnlyEnd: optionalFilterString,
	referenceDate: optionalFilterString,
	contentView: z
		.nativeEnum(SchedulerContentView)
		.optional()
		.default(SchedulerContentView.TIMELINE),
	intentIds: optionalFilterStringArray,
	brandIds: optionalFilterStringArray,
	modelIds: optionalFilterStringArray,
	bodyStyleIds: optionalFilterStringArray,
	minimumSeats: z.number().optional(),
	minimumRange: z.number().optional(),
	minDayPrice: z.number().optional(),
	maxDayPrice: z.number().optional(),
	onlyFavorites: z.boolean().optional(),
	instantBooking: z.boolean().optional(),
	allowPets: z.boolean().optional(),
	allowAbroad: z.boolean().optional(),
});
